<div
    class="agpr-text-input-chips"
    [class.agpr-text-input-chips--hasChips]="value && value.length > 0"
    [ngClass]="{'agpr-text-input-chips--social' : style === agprComponentStyle.social}"
>
    <agpr-text-input
        #textInput
        [id]="id"
        class="agpr-text-input-chips-textInput"
        [disabled]="disabled"
        [readonly]="readonly"
        [placeholder]="placeholder | localize"
        [bottomMargin]="false"
        [(ngModel)]="newChip"
        (focus)="tryWrite()"
        (blur)="onBlur($event)"
        (keydown)="onKeyDown($event)"
        [label]="header"
        [tooltip]="tooltip"
        [ariaLabelledBy]="ariaLabelledBy"
        [ariaInvalid]="ariaInvalid || chipValidationErrors.length > 0"
        [ariaDescribedBy]="(id + '_chips') + ' ' + (id + 'chipValidationErrors') + ' ' + ariaDescribedBy"
    ></agpr-text-input>
    @if (chips.length > 0) {
        <div
            class="agpr-chipsContainer"
        >
            <ul
                #chipList
                [id]="id"
                class="agpr-chips"
                agprListKeyboardNavigation
                listOrientation="horizontal"
                [focusOnChild]="true"
                [list]="value"
                [attr.aria-labelledby]="ariaLabelledBy"
                [ngClass]="{'agpr-chips--withClearAllButton': value.length > 0}"
            >
                <ng-container *ngFor="let chip of chips; index as i">
                    <li
                        class="agpr-chip"
                        [class.agpr-chip--invalid]="!chip.valid"
                        [id]="id + '.chip_' + i"
                        [attr.aria-label]="chip.handle"
                    >
                        @if(!chip.valid) {
                            <span
                                class="agpr-chip-icon-invalid fa-regular fa-circle-minus"
                            ></span>
                        }
                        <span
                            class="agpr-chip-label"
                            [pTooltip]="chip.valid ? chip.handle : chip.handle + ('Social.invalidHandleReason.' + chip.reason | localize)"
                            tooltipPosition="top"
                        >
                            {{ chip.handle }}
                        </span>
                        <button
                            [id]="id + '_chip_' + i + '_delete'"
                            class="agpr-chip-icon agpr-i-close"
                            agprTooltip="Common.forms.chips.delete"
                            [useTooltipAsAriaLabel]="false"
                            tooltipPosition="top"
                            (click)="removeChip(chip)"
                            [attr.aria-label]="chip.handle + ' ' + ('Common.forms.chips.delete' | localize)"
                        ></button>
                    </li>
                </ng-container>
            </ul>
            <agpr-button
                *ngIf="value.length > 0"
                class="agpr-chips-clearAllIcon"
                icon="fa-kit-duotone fa-agpr-remove-all"
                [tooltip]="clearAllChipsTooltip"
                tooltipPosition="top"
                [style]="buttonTypes.icon"
                (click)="removeAllChips()"
            >
            </agpr-button>
        </div>
    }
</div>
<ul [id]="id + 'chipValidationErrors'">
    <li *ngFor="let error of chipValidationErrors">
        <agpr-form-message
            [marginBottom]="0"
        >
            {{ error | localize }}
        </agpr-form-message>
    </li>
</ul>

